document.addEventListener('DOMContentLoaded', () => {
    const cookie = document.querySelector('#cookies');
    if (!localStorage.cookieAccepted) {
        cookie?.classList.remove('hidden');
    }
    cookie?.querySelector('button').addEventListener('click', e => {
        e.preventDefault();
        cookie.classList.add('hidden');
        localStorage.cookieAccepted = true;
    })
})